import { getModel } from "core-web/state";
import { post } from "core-web/libs/GrebbCommerceAPI/util";

export default async (partNos = [], basketId = null) => {
    const applicationId = getModel("application").applicationId;

    const response = await post(`/frontend/basket/populate?application_id=${applicationId}`, {
        part_nos: partNos,
        basket_id: basketId,
    });

    return { response: await response.body(), status: await response.status() };
};
